import {
  Item,
  ItemAvatar,
  ItemContent,
  ItemSide,
  ItemTitle,
} from "@opensea/next-ui-kit"
import type { ItemProps } from "@opensea/ui-kit"
import { Checkbox, classNames, FlexColumn } from "@opensea/ui-kit"
import type React from "react"
import type { ComponentPropsWithoutRef } from "react"

type Props = {
  children: React.ReactNode
}

function CheckboxFilterContent({ children }: Props) {
  return <FlexColumn className="gap-1.5">{children}</FlexColumn>
}

export function CheckboxFilterContentItem({
  className,
  children,
  ...rest
}: ItemProps) {
  return (
    <Item
      asChild
      className={classNames("cursor-pointer gap-3 py-2", className)}
      variant="unstyled"
      {...rest}
    >
      <div>{children}</div>
    </Item>
  )
}

export function CheckboxFilterContentItemTitle({ children }: Props) {
  return (
    <ItemTitle color="text-secondary" size="sm" weight="regular">
      {children}
    </ItemTitle>
  )
}

export function CheckboxFilterContentAvatar({
  className,
  ...rest
}: ComponentPropsWithoutRef<typeof ItemAvatar>) {
  return (
    <ItemAvatar
      className={classNames(
        "order-none fill-text-secondary text-text-secondary",
        className,
      )}
      size={15}
      {...rest}
    />
  )
}

export const CheckboxFilterContentItemCheckbox = Checkbox
export const CheckboxFilterContentItemContent = ItemContent
export const CheckboxFilterContentItemSide = ItemSide

export { CheckboxFilterContent }
